import { ref } from "vue";
import axios from "axios";
import authHeader from "@/Api/AuthHeader";
const URL_API = process.env.VUE_APP_URL_API;

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getPaidInscription() {
      return await axios.get(URL_API + "paid-inscriptions", {
        headers: authHeader(),
      });
    },

    async getInvoices() {
      return await axios.get(URL_API + "invoices", {
        headers: authHeader(),
      });
    },

    async getUnpaidInscriptions() {
      return await axios.get(URL_API + `unpaid-inscriptions`, {
        headers: authHeader(),
      });
    },

    async getPaidRenewInscription() {
      return await axios.get(URL_API + "paid-renewed-inscriptions", {
        headers: authHeader(),
      });
    },

    async getUnpaidRenewedInscriptions() {
      return axios.get(URL_API + `unpaid-renewed-inscriptions/`, {
        headers: authHeader(),
      });
    },

    async confirm_payment(data) {
      let file = new FormData();

      file.append("file", data.file_payment);

      return axios.post(URL_API + "upload_file", file, {
        headers: authHeader(),
      });
    },

    async confirmPayment_(inscriprions_id) {
      return axios.get(
        URL_API + `confirmPayment_?inscription_id=${inscriprions_id}`,
        {
          headers: authHeader(),
        }
      );
    },

    async getAllpayments(data) {
      return axios.get(URL_API + `feepayments?page=${data.page}`, {
        headers: authHeader(),
      });
    },
    /**
     *const searchData = ref({
  month: "",
  endMonth: "",
  year: "",
  card_id: null,
  fineType: "1",
  payment_status: "",
}); 
     */
    async searchPaymentByStudent(data) {
      return axios.get(
        URL_API +
          `getFeePaymentByStudent?payment_status=${data.payment_status}&card_id=${data.card_id}&month=${data.month}&fineType=${data.fineType}&year=${data.year}`,
        { headers: authHeader() }
      );
    },

    async extractsByStudent(card_id) {
      return axios.get(URL_API + `extractsByStudent?card_id=${card_id}`, {
        headers: authHeader(),
      });
    },
    async generateExtractsByStudent(card_id) {
      return axios.get(
        URL_API + `generateExtractsByStudent?card_id=${card_id}`,
        { headers: authHeader() }
      );
    },
    async getPaymentPerCurrentYear(card_id, year) {
      return axios.get(
        URL_API + `extractsByStudent?card_id=${card_id}&year=${year}`,
        {
          headers: authHeader(),
        }
      );
    },

    async searchPaymentDebtByCourse(data) {
      return axios.get(
        URL_API +
          `searchPaymentDebtByCourse?scholar_shift=${data.scholar_shift}&course_id=${data.course_id}&month=${data.month}&endMonth=${data.endMonth}&year=${data.year}&academic_degree=${data.academic_degree}`,
        { headers: authHeader() }
      );
    },
    async searchPaymentInscriptionsBycourse(data) {
      return axios.get(
        URL_API +
          `searchPaymentInscriptionsBycourse?course_id=${data.course_id}&year=${data.year}`,
        { headers: authHeader() }
      );
    },

    downloadPDF(card_id) {
      return axios.get(URL_API + `extracto-pdf/${card_id}`, {
        headers: authHeader(),
      });
    },
  },
};
